// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";

const name = "transmittancePixelShader";
const shader = `#define RENDER_TRANSMITTANCE
#define EXCLUDE_RAY_MARCHING_FUNCTIONS
#include<atmosphereUboDeclaration>
#include<helperFunctions>
#include<atmosphereFunctions>
varying vUV: vec2f;
@fragment
fn main(input: FragmentInputs)->FragmentOutputs {fragmentOutputs.color=renderTransmittance(input.vUV);}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("../ShadersWGSL/ShadersInclude/atmosphereUboDeclaration"),
    import("core/ShadersWGSL/ShadersInclude/helperFunctions"),
    import("../ShadersWGSL/ShadersInclude/atmosphereFunctions")
]));
/** @internal */
export const transmittancePixelShaderWGSL = { name, shader };
